export default __webpack_public_path__ + "static/media/red.c7621e1e.png";